"use client";

import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "../banner.module.css";
import { cn } from "@/src/utils/shadcn";
import {
  CertificateModelSection,
  CertificateModelSectionProps,
} from "@/src/sections/banner-model/certificate";
import Image from "next/image";

const iconStyle = cn(
  `md:w-[100px] h-[100px] rounded-full bg-transparent duration-350 text-white transition-all`
);
const cursorStyle = cn(`cursor-pointer`);

export const CertificateDialog = ({ cards }: CertificateModelSectionProps) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowModal(false);
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  const Modal = () => {
    return (
      <div
        data-testid="backdrop"
        className={styles["modal-video"]}
        role="dialog"
        onClick={() => setShowModal(false)}
      >
        <div className={styles["modal-video-body"]}>
          <div className={styles["modal-video-inner"]}>
            <div className={styles["modal-video-wrap"]}>
              <button
                className={styles["modal-video-close-btn"]}
                onClick={() => setShowModal(false)}
              />
              <CertificateModelSection cards={[...cards]} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div data-testid="video-player mx-2">
      <span
        className={cn(cursorStyle, "z-10")}
        onClick={() => setShowModal(true)}
      >
        <span className={cn(iconStyle, "text-[2.5rem] md:text-[6.25rem]")}>
          <span>
            <Image
              width={100}
              height={100}
              src="/assets/images/premier-standards/Certificates.webp"
              alt="Awards"
            />
          </span>
        </span>
      </span>

      {showModal && createPortal(<Modal />, document.body)}
    </div>
  );
};
